/* lm-video.js — decide se o vídeo toca sozinho, e só então o baixa.

   MEDIDO em 06/08: o vídeo da home tem 22 MB numa única rendição (1080p a
   7,2 Mbps). Não existe versão menor no CDN para servir no lugar. O Safari
   escapa pelo HLS, que adapta sozinho; o Chrome não lê HLS e pegaria os 22 MB
   inteiros. Então no celular a resposta é não baixar: fica na capa e o
   visitante toca se quiser.

   O HTML sai com `preload="none"` e sem `autoplay`. Quem liga é este arquivo.
   Sem JavaScript, o visitante vê a capa e os controles — nunca uma tela preta. */
(function () {
  'use strict';

  var ESTREITO = '(max-width: 767px)';
  var observadores = new WeakMap();

  function economizando() {
    var c = navigator.connection;
    return !!c && (c.saveData === true || /(^|-)2g$/.test(c.effectiveType || ''));
  }

  function preparar(v) {
    if (v.dataset.lmPronto) return;
    v.dataset.lmPronto = '1';

    var quer = v.dataset.lmAuto === 'true';
    var querMob = v.dataset.lmAutoMob === 'true';
    var estreito = window.matchMedia(ESTREITO).matches;

    if (!quer || economizando() || (estreito && !querMob)) {
      v.setAttribute('controls', '');   /* dá ao visitante como tocar */
      return;
    }

    v.preload = v.dataset.lmPrecarga || 'metadata';

    if (!('IntersectionObserver' in window)) {
      v.autoplay = true;
      v.play().catch(function () {});
      return;
    }

    /* Só busca o vídeo quando a seção chega perto da tela, e pausa ao sair. */
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px' });

    obs.observe(v);
    observadores.set(v, obs);
  }

  function ligar(raiz) {
    (raiz || document).querySelectorAll('video[data-lm-video]').forEach(preparar);
  }

  function desligar(raiz) {
    (raiz || document).querySelectorAll('video[data-lm-video]').forEach(function (v) {
      var obs = observadores.get(v);
      if (obs) { obs.disconnect(); observadores.delete(v); }
      delete v.dataset.lmPronto;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ligar(); });
  } else {
    ligar();
  }

  /* O editor de temas re-renderiza a seção a cada edição. */
  document.addEventListener('shopify:section:load', function (e) { ligar(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { desligar(e.target); });
})();
